<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="verify-box"
    style="width: 400px"
  >
    <el-dialog
      v-if="resData"
      title="理赔申请"
      :visible="true"
      :before-close="onCloseDialog"
      width="380"
    >
      <el-form style="margin-left: 10%">
        <el-form-item label="工单数量：">
          {{ resData.count }}
        </el-form-item>
        <el-form-item label="商品件数：">
          {{ resData.no_back_num }}
        </el-form-item>
        <el-form-item label="退款金额：">
          {{ resData.refund_goods_money }}
        </el-form-item>
        <el-form-item label="理赔类型：">
          <el-select
            v-model="form.f_type"
            placeholder="请选择"
            size="mini"
            style="margin-right: 8px"
            @change="setType"
          >
            <el-option
              v-for="item in resData.type.filter((t) => t.parent_id == 0)"
              :key="item.claims_type_id"
              :label="item.title"
              :value="item.claims_type_id"
            ></el-option>
          </el-select>
          <el-select v-model="form.type" placeholder="请选择" size="mini">
            <el-option
              v-for="item in types"
              :key="item.claims_type_id"
              :label="item.title"
              :value="item.claims_type_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费方式：">
          <el-select
            v-model="form.billing_method"
            placeholder="请选择"
            size="mini"
            style="margin-right: 8px"
            @change="getMoney()"
          >
            <el-option
              v-for="item in billing_mehtods"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-input
            v-model="form.billing_rate"
            placeholder="输入比例"
            size="mini"
            style="width: 200px"
            @blur="getMoney()"
          ></el-input>
        </el-form-item>
        <el-form-item label="理赔运费：">
          <el-input
            v-model="form.shipping_fee"
            placeholder="输入理赔运费"
            size="mini"
            style="width: 450px"
          ></el-input>
        </el-form-item>
        <el-form-item label="理赔金额：">
          {{ billing_money }}
        </el-form-item>
        <el-form-item label="理赔月份：">
          <el-date-picker
            v-model="form.shipping_month"
            format="yyyy-MM"
            type="month"
            placeholder="选择月"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="提交说明：">
          <el-input
            v-model="form.remark"
            type="textarea"
            placeholder="输入提交说明"
            size="mini"
            style="width: 400px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onCloseDialog">取 消</el-button>
          <el-button type="primary" @click="submitData">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Claims",
  props: {
    workIds: {
      type: Array,
      default: () => [],
    },
    claimsDetailId: {
      type: Array,
      default: () => [],
    },
    origin: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      billing_money: 0,
      form: {
        billing_method: 2,
      },
      types: [],
      resData: null,
      loading: false,
      is_first: 0,
      dbid: "",
      num: 0,
      verify_num: 0,
      data: [],
      can_out: 0,
      print_data: "",
      fullscreenLoading: false,
      url: "/erp/Claims/beforeClaims",
      billing_mehtods: [
        // {
        //     id:1,
        //     name:'按代采价',
        // },
        {
          id: 2,
          name: "按平台价",
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    getMoney() {
      this.$http
        .post("/erp/claims/getClaimsMoney", this.form)
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code !== 200) {
            this.$message.error(result.data.msg);
          } else {
            this.billing_money = result.data.data.money;
          }
        })
        .catch(() => {
          return this.$message.error("数据获取失败");
        });
    },
    fetchData() {
      // comment
      if (!this.workIds) {
        this.$message.error("工单ID不存在");
        return;
      }
      this.form.work_ids = this.workIds;
      this.form.claims_detail_id = this.claimsDetailId;
      this.form.origin = this.origin;
      this.fullscreenLoading = true;
      this.$http
        .post(this.url, {
          work_ids: this.workIds,
          claims_detail_id: this.claimsDetailId,
        })
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code !== 200) {
            this.onCloseDialog();
            this.$message.error(result.data.msg);
            return;
          }
          this.resData = result.data.data;
        })
        .catch(() => {
          this.onCloseDialog();
          return this.$message.error("数据获取失败");
        });
    },
    setType(value) {
      this.types = [];

      this.resData.type.forEach((ele, i) => {
        if (ele.parent_id === value) {
          this.types.push(this.resData.type[i]);
        }
      });
    },
    submitData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/claims/claims", this.form)
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code !== 200) {
            return this.$message.error(result.data.msg);
          }
          this.onCloseDialog();
          return this.$message.success(result.data.msg);
        })
        .catch(() => {
          return this.$message.error("数据获取失败");
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog", false);
    },
    resetData() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/claims/components/Claims.vue